import { actions, types } from './requests'
export const GETDEPOSIT_TYPES = {
    ...types('GETDEPOSIT'),
}
export const GETDEPOSIT_ACTIONS = {
    ...actions('GETDEPOSIT'),
}
